import { MuiComponent } from "./type";
import * as Colors from "../colors";

export const MuiInputAdornment: MuiComponent<"MuiInputAdornment"> = {
  styleOverrides: {
    root: {
    },
  },
  variants: [
    {
      props: { variant: "filled" },
      style: {
        color: 'white',
        padding: "19px 16px",
        backgroundColor: Colors.BorderGray,

        '&.MuiInputAdornment-positionEnd': {
          marginRight: "-13.5px",
          borderTopRightRadius: "11px",
          borderBottomRightRadius: "11px",
        },

        '& > p': {
          fontSize: "14px",
          color: "white",
        },
      },
    },
  ],
};